import React,{useEffect,useState} from 'react'
import { Container, Breadcrumb, BreadcrumbItem, Row, Col } from 'reactstrap'
import { NavLink } from 'react-router-dom'
import { directUrl, homePageUrl } from '../../../helpers/Constants'
import { useParams ,useLocation,useNavigate} from 'react-router-dom'
import { requestApi } from '../../../request-api'
import { FaCheckCircle } from "react-icons/fa";

function ApproverLegislationListViews() {
 let [legislation,setLegislation]=useState([])
 let [legislationName,setLegislationName] = useState([])
 let [reportName,setReportName] = useState("")
 let {reportId} =  useParams()
 const location = useLocation();
 let navigate = useNavigate()

 console.log(reportId)
    const getData =()=>{
        
        requestApi(`/auditor/approver/getLegislationByReport/${reportId}`,{
            method:'get'
        }).then((data)=>{
            console.log("first",data.data)
            setLegislation(data.data)
            let legName =[]
            data.data.map((leg)=>{
                legName.push(leg.legislation_name)
            })
            setLegislationName(legName)
        })



    }
 useEffect(()=>{
    // setReportName(location.state.report_name)
    console.log("location.state.report_name",location)
        getData()
   
 },[])
  return (
    <section className='lyt-section'>
        <Container fluid className='typ-container'>
            <Breadcrumb className='bs-breadcrumb mt-0'>
                <BreadcrumbItem><NavLink to={`${directUrl}approver/reports-approver`}>Reports</NavLink></BreadcrumbItem>
                <BreadcrumbItem>{location.state.row.report_id}</BreadcrumbItem>
                <BreadcrumbItem active>Legislation</BreadcrumbItem>
            </Breadcrumb>
            <Row>
                <Col xs={12} sm={12} md={12} lg={9} xl={8}>
                    <ul className='bs-list'>                        
                        {legislation.map((leg)=>(                           
                           <li><NavLink 
                           onClick={(e) => {
                            e.preventDefault();
                            navigate(
                              `${directUrl}approver/view/legislation-list/${reportId}/${leg.id}`,
                              { state: { leg: leg, row: location.state.row } }
                            );
                          }}
                           
                           >
                            {leg.legislation_name}
                           </NavLink> {leg.status == 1 ? <FaCheckCircle /> : '' }</li> 
                        ))}                     
                    </ul>
                </Col>
            </Row>
        </Container>
    </section>
  )
}

export default ApproverLegislationListViews
